import React from 'react';

const CalorieRing = ({ value = 0, goal = 2000, size = 200, stroke = 14, label, color = '#047857' }) => {
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const pct = Math.min(value / goal, 1);
  const dash = circ * pct;
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size/2} cy={size/2} r={radius} stroke="#e6efe9" strokeWidth={stroke} fill="none" />
        <circle cx={size/2} cy={size/2} r={radius} stroke={color} strokeWidth={stroke} fill="none" strokeDasharray={`${dash} ${circ}`} strokeLinecap="round" style={{ transition: 'stroke-dasharray 0.8s ease' }} />
      </svg>
      <div className="absolute inset-0 grid place-items-center text-center">
        <div>
          <div className="font-display text-4xl font-bold text-emerald-950">{Math.round(value)}</div>
          <div className="text-xs uppercase tracking-wider text-emerald-950/50">{label || `of ${goal} kcal`}</div>
        </div>
      </div>
    </div>
  );
};

export default CalorieRing;
